module.exports = __webpack_public_path__ + "img/2.03.thmb.f07a6b1d.jpg";